// File: src/hooks/useTags.js
// دریافت لیست برچسب‌ها و جلسات یک برچسب از API

import { useState, useEffect } from 'react';
import { API_SETTINGS } from '../data/constants';

// آدرس API برچسب‌ها — کنار settings.php قرار می‌گیرد
const TAGS_API = API_SETTINGS.replace('settings.php', 'tags.php');

/* همه برچسب‌های فعال */
export function useTags() {
  const [tags, setTags]       = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    fetch(`${TAGS_API}?action=list`, { cache: 'no-store' })
      .then(r => r.json())
      .then(j => { if (alive) setTags(j.success ? (j.data || []) : []); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { tags, loading };
}

/* جلسات یک برچسب خاص بر اساس slug */
export function useTagMeetings(slug) {
  const [data, setData]       = useState({ tag: null, meetings: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!slug) { setData({ tag: null, meetings: [] }); return; }
    let alive = true;
    setLoading(true); setError(null);
    fetch(`${TAGS_API}?action=by_tag&slug=${encodeURIComponent(slug)}`, { cache: 'no-store' })
      .then(r => r.json())
      .then(j => {
        if (!alive) return;
        if (j.success && j.data) {
          // normalize سبک
          const meetings = (j.data.meetings || []).map(m => ({
            ...m,
            days_array: Array.isArray(m.days_array) ? m.days_array.map(Number) : [],
            id: Number(m.id),
            city_id: m.city_id ? Number(m.city_id) : null,
            zone_id: m.zone_id ? Number(m.zone_id) : null,
            province_id: m.province_id ? Number(m.province_id) : null,
            todayStartTime: m.first_start_time || '',
          }));
          setData({ tag: j.data.tag, meetings });
        } else {
          setError(j.message || 'برچسب یافت نشد');
        }
      })
      .catch(() => { if (alive) setError('خطا در اتصال به سرور'); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [slug]);

  return { ...data, loading, error };
}
